import {convertToInt} from '@utils/helpers';
import {EVENT_TYPE_SPORTRADAR, EVENT_TYPE_STAGE} from '@constants/variables';

/**
 * Check if event is
 * - Sportradar
 * @returns {boolean}
 */
export const isSportradarEvent = (event) => (
    EVENT_TYPE_SPORTRADAR === convertToInt(event.event_type.id)
);

/**
 * Check if event is
 * - Stage
 * @returns {boolean}
 */
export const isStageEvent = (event) => (
    event?.event_type?.id && convertToInt(event.event_type.id) === EVENT_TYPE_STAGE
);
